import { getAppData, getAppConfig } from 'larasnap';
import { AddressField } from 'larasnap/enums';
import { moment, plural } from 'larasnap/support';
import loadGoogleMapsApi from 'load-google-maps-api';
import merge from 'lodash-es/merge';
import isObject from 'lodash-es/isObject';
import isMatch from 'lodash-es/isMatch';
import get from 'lodash-es/get';
import set from 'lodash-es/set';
import isEqual from 'lodash-es/isEqual';

export const time = val => {
    return moment(val, 'HH:mm:ss');
};

export const ts = val => {
    return moment(val).valueOf();
};

export const isSameDay = (a, b) => moment(a).startOf('day').isSame(moment(b).startOf('day'));

export const parseBind = str => {
    const [type, name] = str.split('.');
    return { type, name };
};

export const getObject = (obj, key = null) => (key ? get(obj, key) : obj);

export const setObject = (obj, key, value) => {
    if (typeof key === 'string') {
        return set(obj, key, value);
    } else if (isObject(key)) {
        return merge(obj, key);
    }
};

export const filterByPrefix = (obj, prefix) => {
    return Object.fromEntries(
        Object.entries(obj)
            .filter(([field]) => field.startsWith(`${prefix}_`))
            .map(([field, value]) => [field.replace(`${prefix}_`, ''), value]),
    );
};

export const getUrlParam = name => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
};

export const getAssetUrl = path => {
    return getAppData('asset_url') + path;
};

export const getImageUrl = path => {
    return getAssetUrl(`images/${path}`);
};

export const refresh = () => {
    window.location.reload();
};

export const hasAccess = permission => {
    const obj = getAppData('permissions');
    return obj[permission] || false;
};

export const loadGoogleMaps = (options = {}) => {
    const { key, endpoint, libraries } = getAppConfig('google.maps.client');
    return loadGoogleMapsApi({
        key,
        libraries,
        apiUrl: endpoint,
        ...options,
    });
};

export const remove = (arr, condition) => {
    for (let i = 0, length = arr.length; i < length; i++) {
        const isFunction = typeof condition === 'function';

        if (
            (isFunction && condition(arr[i]) === true) ||
            (!isFunction && isObject(condition) && isMatch(arr[i], condition)) ||
            condition === arr[i]
        ) {
            arr.splice(i, 1);
            i--; // We just removed an item from the array, so we
            length--; // need to set the index and length back by 1
        }
    }
};

export const createVueApp = (name, props = [], data = []) => {
    const element = $(`<div class="vue-app" data-name="${name}"/>`);
    element.data('app-props', props);
    element.data('app-data', data);
    return element;
};

export const vueApp = name => {
    return $('body').vueApp(name);
};

export const snapgrid = name => {
    return $('body').snapgrid(name);
};

export const routeRedirect = (route, params = [], queryString = '') => {
    if (isObject(queryString)) {
        queryString = object_to_querystring(queryString);
    }

    $("input[name='larasnapRedirectData']").val(
        JSON.stringify({
            route,
            params,
            queryString,
        }),
    );

    document.getElementById('larasnapRedirect').submit();
};

export const currentRouteRedirect = (params, queryString = '') => {
    routeRedirect(getAppData('current_route'), params, queryString);
};

export const object_to_querystring = param =>
    Object.entries(param)
        .reduce((pairs, [key, val]) => pairs.concat(`${key}=${val}`), [])
        .join('&');

export const getAddressFields = (obj, prefix = 'address') => {
    prefix = prefix + '_';

    const address = Object.fromEntries(
        Object.values(AddressField).map(field => [field, obj[prefix + field] ?? '']),
    );

    address.street = address.street1;
    if (address.street2) {
        address.street += ', ' + address.street2;
    }

    return address;
};

export const pipe =
    (...fns) =>
    x =>
        fns.reduce((result, f) => f(result), x);

export const urlDate = date => moment(date).format('YYYY-MM-DD');

export const readableDuration = (minutes, { long = false } = {}) => {
    const duration = moment.duration({ minutes });
    const text = [];
    if (duration.hours()) {
        text.push(long ? plural('hour', duration.hours()) : duration.hours() + ' hr');
    }
    if (duration.minutes()) {
        text.push(long ? plural('minute', duration.minutes()) : duration.minutes() + ' min');
    }
    if (!duration.hours() && !duration.minutes()) {
        text.push('0 min');
    }

    return text.join(' ');
};

export const notPartOf = arr => item => !arr.includes(item);

export const toggle = (arr, item) => {
    const index = arr.findIndex(x => isEqual(x, item));
    index !== -1 ? arr.splice(index, 1) : arr.push(item);
    return index === -1;
};

export const uuid = () => {
    // Get the current time in milliseconds since the Unix epoch.
    var dt = new Date().getTime();
    // Replace the placeholders in the UUID template with random hexadecimal characters.
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // Generate a random hexadecimal digit.
        var r = (dt + Math.random() * 16) % 16 | 0;
        // Update dt to simulate passage of time for the next random character.
        dt = Math.floor(dt / 16);
        // Replace 'x' with a random digit and 'y' with a specific digit (4 for UUID version 4).
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    // Return the generated UUID.
    return uuid;
};
